export const FETCH_ALL = "FETCH_ALL";
export const CLEAR = "CLEAR";

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
